import { isUndefined } from '@aloft/toolkit-shared';
import { Select, SelectProps } from '@aloft/toolkit-sui';

import { Controller, useFormContext } from 'react-hook-form';

import { Td } from '../table.tsx';
import { FilterTableFieldName } from './types.ts';

export const StringSelect = ({
  name,
  options,
  colSpan = 2,
  placeholder,
  storeAsSingleElementArray,
}: {
  name: FilterTableFieldName;
  options: SelectProps<string>['options'];
  colSpan?: number;
  placeholder?: string;
  storeAsSingleElementArray?: boolean;
}) => {
  const { control } = useFormContext();
  return (
    <Td colSpan={colSpan} type="editable">
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => {
          const selectValue = storeAsSingleElementArray
            ? Array.isArray(field.value)
              ? (field.value[0] ?? '')
              : (field.value ?? '')
            : field.value;

          return (
            <Select
              id={name}
              options={options}
              size="sm"
              border={false}
              radius={false}
              isInvalid={fieldState.invalid}
              {...field}
              value={selectValue}
              onChange={(value) => {
                if (storeAsSingleElementArray) {
                  field.onChange(isUndefined(value) || value === '' ? [] : [value]);
                  return;
                }
                if (isUndefined(value)) {
                  field.onChange('');
                } else {
                  field.onChange(value);
                }
              }}
              placeholder={placeholder}
            />
          );
        }}
      />
    </Td>
  );
};
